import { useState } from 'react';
import { File, FilePdf, PlayCircle, MusicNote } from '@phosphor-icons/react';
import { getMediaUrl } from '../../utils/uploadService';

const ComplaintAttachmentPreview = ({ media, index }) => {
    const [failed, setFailed] = useState(false);
    const url = getMediaUrl(media);
    if (!url || !/^(https?:\/\/|\/)/i.test(url)) return null;

    const metadata = typeof media === 'object' && media ? media : {};
    const filename = metadata.originalName || metadata.original_name || metadata.fileName || metadata.filename || metadata.name || '';
    const mime = String(metadata.mimeType || metadata.mimetype || metadata.contentType || metadata.type || '').toLowerCase();
    const path = url.split(/[?#]/)[0];
    const extension = (filename || path).split('.').pop().toLowerCase();
    const kind = mime.startsWith('image/') || ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg', 'avif', 'bmp'].includes(extension) ? 'image'
        : mime === 'application/pdf' || extension === 'pdf' ? 'pdf'
        : mime.startsWith('video/') || ['mp4', 'webm', 'ogv', 'mov', 'm4v', 'avi', 'mkv', '3gp'].includes(extension) ? 'video'
        : mime.startsWith('audio/') || ['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac'].includes(extension) ? 'audio' : 'file';
    const label = filename || `Attachment ${index + 1}`;
    const FallbackGlyph = kind === 'pdf' ? FilePdf : kind === 'audio' ? MusicNote : File;
    const fallback = <div className="complaint-attachment-fallback"><FallbackGlyph size={32} weight="duotone" aria-hidden="true" /><span>{failed ? 'Open to view' : kind.toUpperCase()}</span></div>;

    return (
        <figure className="complaint-attachment-preview">
            <a className="complaint-attachment-canvas" href={url} target="_blank" rel="noopener noreferrer" aria-label={`Open ${label} in a new tab`}>
                {failed ? fallback : kind === 'image' ? (
                        <img src={url} alt={label} loading="lazy" onError={() => setFailed(true)} />
                ) : kind === 'pdf' ? (
                    <div className="complaint-pdf-thumbnail" aria-hidden="true">
                        <object data={`${url.split('#')[0]}#page=1&toolbar=0&navpanes=0&scrollbar=0&view=FitH`} type="application/pdf" tabIndex={-1}>{fallback}</object>
                    </div>
                ) : kind === 'video' ? (
                    <><video src={url} muted playsInline preload="metadata" aria-hidden="true" tabIndex={-1} onError={() => setFailed(true)} /><PlayCircle className="complaint-video-play" size={34} weight="fill" aria-hidden="true" /></>
                ) : kind === 'audio' ? (
                    fallback
                ) : fallback}
                <span className="complaint-attachment-type">{kind === 'file' ? 'FILE' : kind.toUpperCase()}</span>
            </a>
            <figcaption>
                <a href={url} target="_blank" rel="noopener noreferrer" title={label}>{label}</a>
            </figcaption>
        </figure>
    );
};

export default ComplaintAttachmentPreview;
